import { Component, input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-menu-section-cabinet',
    templateUrl: './menu-section.component.html',
    styleUrl: './menu-section.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class MenuSectionCabinetComponent {
    isCollapsed = input(false);
    isFullHeight = input(false);
}
